//  ----------      START   IMPORT  BLOCK       ----------
import { 
  FaInstagram, 
  FaTiktok, 
  FaTwitter, 
  FaYoutube 
} from 'react-icons/fa';
//  Context
import { useLanguage } from '../../../../../API/Context/LanguageContext';
//  Utils
import ExternalLink from '../../../../../Utils/externalLink';
//  Config
import { FRONTEND_ROUTES } from '../../../../../ConfigFiles/Routes/frontend_routes';
import { VocabSocials } from '../../../../../ConfigFiles/multilingual/VocabSocials';
import './SocialFooter.css';
//  ----------      END   IMPORT  BLOCK       ----------

const SocialFooter = () => {
  const { lan } = useLanguage();
  return (
    <div className="confirm-footer text-center">
      {/* Sober Title */}
      <p className="footer-label fw-bold small text-secondary mb-3 text-uppercase" style={{ letterSpacing: '1px' }}>
        {VocabSocials.connect_with_us[lan]}
      </p>

      {/* Modern Icon Row */}
      <div className="social-links-row d-flex justify-content-center gap-4 mb-3">
        <ExternalLink href={FRONTEND_ROUTES.SOCIAL_INSTA} className="text-secondary opacity-75 hover-primary">
            <FaInstagram size={20} />
        </ExternalLink>
        <ExternalLink href={FRONTEND_ROUTES.SOCIAL_TWITTER} className="text-secondary opacity-75 hover-primary">
            <FaTwitter size={20} />
        </ExternalLink>
        <ExternalLink href={FRONTEND_ROUTES.SOCIAL_TIKTOK} className="text-secondary opacity-75 hover-primary">
            <FaTiktok size={20} />
        </ExternalLink>
        <ExternalLink href={FRONTEND_ROUTES.SOCIAL_YOUTUBE} className="text-secondary opacity-75 hover-primary">
            <FaYoutube size={20} />
        </ExternalLink>
      </div>

      {/* Slogan */}
      <div className="small text-muted opacity-50 fst-italic" style={{ fontSize: '0.7rem' }}>
        {VocabSocials.socials_footer[lan]}
      </div>
    </div>
  );
};

export default SocialFooter;